import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NgbActiveModal, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {Destinazione} from "../../Models/destinazione";
import {ApiRestService} from "../../_services/api-rest.service";
import {ApiRestService as ClientiApiRestService} from "../../../Admin/_service/api-rest.service";
import {DestinazioneVociListComponent} from "../destinazione-voci-list/destinazione-voci-list.component";
import {ToastrService} from "ngx-toastr";
import {Azienda} from "../../../Admin/models/Azienda";
import {Sede} from "../../../Admin/models/Sede";
import {IDropdownSettings} from "ng-multiselect-dropdown";
import { environment } from 'src/environments/environment';
import {ApiPathsService} from "../../../api-paths.service";

@Component({
  selector: 'app-destinazioni-edit',
  templateUrl: './destinazioni-edit.component.html',
  styleUrls: ['./destinazioni-edit.component.css']
})
export class DestinazioniEditComponent implements OnInit {
  environment = environment;
  @Input() item: Destinazione;
  @Output() Refresh = new EventEmitter()
  @Input() Cliente: Azienda;
  Sedi: Sede[] = [];
  sediDropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    idField: 'codAdhoc',
    textField: 'fullAddress',
    searchPlaceholderText: "inserire almeno 3 caratteri",
    allowSearchFilter: true,
    allowRemoteDataSearch: false,
  };
  SelectedSede: Sede[] = [];
  loaded=0;
  constructor(
    private ngbModal: NgbModal,
    private activeModalService: NgbActiveModal,
    private apiRest: ApiRestService,
    private apiPaths: ApiPathsService,
    private toastService: ToastrService,
    private clientiApi: ClientiApiRestService,
  ) { }

  ngOnInit(): void {
      this.SelectedSede = [this.item['sedeObjectAdhoc']];
      this.RefreshClienti(this.Cliente);
  }

  closeBtnClick() {
    this.activeModalService.dismiss();
  }

  saveClick(close?: boolean) {
    if(this.item?.id)
      this.apiRest.UpdateDestinazione(this.item).subscribe(()=>{
        if(close)  this.activeModalService.dismiss();
        this.Refresh.emit();
      })
    else
      this.apiRest.AddDestinazione(this.item).subscribe(()=>{
        if(close)  this.activeModalService.dismiss();
        this.Refresh.emit();
      })
  }

  EditVoce(item?: any) {
    if (!item) {
      this.apiRest.GetVociProgetto({id:this.item.progetto}).subscribe(voci=>{
        let modale = this.ngbModal.open(DestinazioneVociListComponent, {
          centered: true,
          backdrop: 'static',
          size: 'xl',
        });
        (<DestinazioneVociListComponent>modale.componentInstance).items = voci?.data;
        (<DestinazioneVociListComponent>modale.componentInstance).AddClick.subscribe(voce => {
          if (!this.item?.voci?.find(x => x.voce_id == voce.voce_id)) {
            const sel = Object.assign({}, voce)
            sel.id = undefined;
            this.item?.voci?.push(sel);
            this.toastService.success("Voce inserita correttamente");
          }
          else {
            const idx: number = this.item?.voci?.findIndex(x => x.voce_id == voce.voce_id)
            if (idx > -1) {
              this.item.voci[idx].quantita = this.item?.voci[idx]?.quantita + voce.quantita;
              if (this.item?.voci[idx]?.quantita > this.item?.voci[idx]?.disponibilita){
                this.toastService.warning("La quantità inserita è maggiore della disponoibilità ("+voce.disponibilita.toString()+")");
                this.item.voci[idx].quantita = this.item.voci[idx].disponibilita
              }
            }
          }
        });
      })

    }
    else if(item.modifica ){
      if (item.quantita <=  item.disponibilita)
        item.modifica = !item.modifica;
      else
        this.toastService.warning("La quantità inserita è maggiore della disponoibilità ("+item.disponibilita.toString()+")");
    }else
      item.modifica = !item.modifica;
  }

  DeleteVoce(item: any) {
    if(item.modifica) {
      item.modifica = !item.modifica;
      return;
    }
    const idx: number = this.item?.voci?.findIndex(x => x == item);
    if (idx > -1) {
      this.item?.voci?.splice(idx, 1);
    }
  }

  refresh() {

  }

  private RefreshClienti(data: Azienda) {
    this.item.nominativo = data?.nominativo;
    this.item.telefono = data?.telefono;
    this.item.email = data?.email;
    this.apiPaths.ClassicPost("/anagrafica/clienti/sedi/adhoc", {id: data?.id}).subscribe(data => {
        this.Sedi = data ?? []
        this.SelectedSede =  this.SelectedSede ?? ([data.find(x=>true)] ?? []);
    })
    // this.clientiApi.getSediCliente(data).subscribe(data => {
    //   this.Sedi = data ?? []
    //   this.SelectedSede = data ?? []
    // })
  }

  sedeCambiata() {
    if((!this.item?.id || this.item.codAdhoc != this.SelectedSede[0].codAdhoc) && this.loaded>0){
      if(this.SelectedSede?.length>0) {
        this.item.indirizzo = this.SelectedSede[0].indirizzo;
        this.item.cap = this.SelectedSede[0].cap;
        this.item.citta = this.SelectedSede[0].citta;
        this.item.provincia = this.SelectedSede[0].provincia;
        this.item.sede = this.SelectedSede[0].id;
        this.item.codAdhoc = this.SelectedSede[0].codAdhoc;
      } else {
        this.item.indirizzo = "";
        this.item.cap = "";
        this.item.citta = "";
        this.item.provincia = "";
        this.item.sede = undefined;
        this.item.codAdhoc = undefined;
      }
    }else {
      this.loaded+=1;
    }

  }
}
